export function dateArrayToDate(dateArray: number[]) {
  if (!dateArray || !dateArray.length) {
    return null;
  }
  const [year, month, day, hour = 0, minute = 0] = dateArray;
  return new Date(year, month - 1, day, hour, minute);
}
